module.exports = __webpack_public_path__ + "img/cta.8d10504a.webp";